import React from 'react';
import { useTranslation } from 'react-i18next';
import CAppSubTitle from '../../../../app/components/CAppSubTitle';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import IFund from '../../interfaces/fund/IFund';
import investmentFundLang from '../../langs/investmentFundLang';
import AppLoaderContent from '../../../../app/features/loader/content/AppLoaderContent';
import { Box } from '@mui/material';
import CTableAssets from '../../components/table/CTableAssets';
import useInvestmentAssetFundSG from '../../hooks/fund/useInvestFundAssetsSG';
import moment from 'moment';

type VInvestFundAssetsListProps = {
	fund: IFund;
};

const VInvestFundAssetsListListedAssets = (props: VInvestFundAssetsListProps) => {
	const { fund } = props;

	const { t } = useTranslation();

	const { isFetching, fundAssets } = useInvestmentAssetFundSG(fund.id);

	return isFetching ? (
		<AppLoaderContent />
	) : fundAssets?.assetsFund ? (
		<>
			<CAppSubTitle
				title={t(investmentFundLang.title_assets.tag)}
				icon={<AppCustomIcon tag="fund_assets" className="icon" />}
				subtitle={t(investmentFundLang.subtitle_assets_reporting_period.tag, {
					reportingPeriod: moment(fundAssets.valuationDate).format('DD/MM/YYYY'),
				})}
			/>
			<Box id="fund-assets-items" sx={{ padding: '10px' }}>
				<CTableAssets
					rows={fundAssets.assetsFund.map((x, index) => ({
						...x,
						id: index,
					}))}
				/>
			</Box>
		</>
	) : (
		<></>
	);
};

export default VInvestFundAssetsListListedAssets;
